export default {
    props: {
        callId: {
            type: String,
            required: true
        },
        parentAttrs: {
            type: Object,
            default: () => ({})
        }
    },

    data() { return {
        callData: null,
        remainingSeconds: null,
        interval: null,
        eventSpace: 'cart-rule.confirm',
        checked: false,
    }},

    computed: {
        rule() {
            return this.callData.rule || {}
        },
        confirmationOptions() {
            return this.rule.confirmation_options || {}
        },
        confirmationId() {
            return this.confirmationOptions.unique_identifier
        },
        confirmationIdKebab() {
            return (this.confirmationId || '')
                .replace(/([A-Z])/g, '-$1')
                .toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '')
        },
        containerClass() {
            const id = this.confirmationIdKebab
            const classes = []
            if (id) {
                classes.push(id)
            }
            const hasClasses = {
                'has-image': !!this.image,
                'has-head': !!(this.title || this.subTitle),
                'has-terms': !!this.termsLink,
                'has-description': !!this.description,
                'has-countdown': this.displayEnding
            }
            classes.push(hasClasses)
            const noClasses = Object.entries(hasClasses).reduce((classes, [key, value]) => {
                classes['no-' + key.replace('has-', '')] = !value
                return classes
            }, {})
            classes.push(noClasses)
            return classes
        },
        parentClass() {
            const id = this.confirmationIdKebab
            if (id) {
                return 'cart-rule-' + id
            }
            return []
        },
        parentOptions() {
            const classes = [this.parentClass, this.parentAttrs.class]
            return {
                ...(this.defaultParentOptions || {}),
                ...(this.parentAttrs),
                class: classes,
            }
        },
        title() {
            return this.confirmationOptions.title
        },
        subTitle() {
            return this.confirmationOptions.subtitle
        },
        image() {
            return this.confirmationOptions.image
        },
        description() {
            return this.confirmationOptions.description
        },
        termsLink() {
            return this.confirmationOptions.terms_link
        },
        termsLabel() {
            return this.confirmationOptions.terms_text
        },
        declineTitle() {
            return this.confirmationOptions.decline_button || 'No, thank you'
        },
        acceptTitle() {
            return this.confirmationOptions.accept_button || 'Yes'
        },
        queued() {
            return this.callData.queued
        },
        displayEnding() {
            return this.queued && this.queued.displayEnding ? new Date(this.queued.displayEnding) : null
        },
        remainingSecondsFormatted() {
            const seconds = Math.floor(this.remainingSeconds) % 60
            const minutes = Math.floor(this.remainingSeconds / 60) % 60
            const hours = Math.floor(this.remainingSeconds / 60 / 60)
            return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
        },
    },

    created() {
        this.callData = window.addiesaas.cart_rules.componentCalls[this.callId]

        if (this.displayEnding) {
            this.updateRemainingSeconds()
            this.interval = setInterval(() => this.timer(), 1000)
        }
        this.emit('created', this.rule, () => this)
    },
    async mounted () {
        this.emit('mounted', this.rule, () => this)
        if (this.confirmationOptions.event_notification_type === 'placeholder') {
            await this.$nextTick()
            this.$el.scrollIntoView()
        }
    },
    beforeDestroy () {
        this.emit('beforeDestroy', this.rule, () => this)
    },

    methods: {
        yes() {
            this.emit('accepted', this.rule, () => this)
            this.callData.dismiss()
            this.callData.accept()
        },

        no() {
            this.emit('declined', this.rule, () => this)
            this.callData.dismiss()
        },

        check() {
            this.emit('accepted', this.rule, () => this)
            this.callData.accept()
        },

        uncheck() {
            this.emit('declined', this.rule, () => this)
            this.callData.revert()
        },

        checkbox() {
            this.checked ? this.check() : this.uncheck()
        },

        timer() {
            this.updateRemainingSeconds()
            if (this.remainingSeconds < 1) {
                clearInterval(this.interval)
                this.no()
            }
        },

        updateRemainingSeconds() {
            const now = new Date()
            this.remainingSeconds = (this.displayEnding.getTime() - now.getTime()) / 1000
        },
        emitBoth(name, ...args) {
            this.$emit(name, ...args)
            this.$$emit(name, ...args)
        },
        emit(name, ...args) {
            this.emitBoth(`${this.eventSpace}.${name}`, ...args)
            const id = this.confirmationIdKebab
            if (id) {
                this.emitBoth(`${this.eventSpace}.${id}.${name}`, ...args)
            }
        }
    }
}
